import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Custom hook to track navigation history using sessionStorage
 * This allows us to know where the user came from in a React SPA
 */
export const useNavigationHistory = () => {
  const location = useLocation();

  useEffect(() => {
    try {
      // Get the current navigation history from sessionStorage
      const historyString = sessionStorage.getItem("navigationHistory");
      let history = historyString ? JSON.parse(historyString) : [];

      // Add current location to history (keep last 10 entries)
      history.push(location.pathname);
      if (history.length > 10) {
        history.shift(); // Remove oldest entry
      }

      // Save updated history
      sessionStorage.setItem("navigationHistory", JSON.stringify(history));
    } catch {
      // Storage can be unavailable in embedded iframe environments.
    }
  }, [location.pathname]);
};

/**
 * Get the previous page from navigation history
 */
export const getPreviousPage = () => {
  try {
    const historyString = sessionStorage.getItem("navigationHistory");
    if (!historyString) return null;

    const history = JSON.parse(historyString);
    // Return second to last entry (last entry is current page)
    return history.length >= 2 ? history[history.length - 2] : null;
  } catch {
    return null;
  }
};

/**
 * Clear navigation history
 */
export const clearNavigationHistory = () => {
  try {
    sessionStorage.removeItem("navigationHistory");
  } catch {
    // Ignore storage failures in restricted contexts.
  }
};
